import { render } from "./PageSpecUnit.vue?vue&type=template&id=3db5a7dd&scoped=true"
import script from "./PageSpecUnit.vue?vue&type=script&lang=js"
export * from "./PageSpecUnit.vue?vue&type=script&lang=js"

import "./PageSpecUnit.vue?vue&type=style&index=0&id=3db5a7dd&scoped=true&lang=css"

import exportComponent from "/home/glassplant/agi.co.jp/roots-prod/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db5a7dd"]])

export default __exports__